import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import "./NewSystemModal.scss";
import { DialogActions } from "@mui/material";
import { IApprovalOperationEntity } from "Model/UI";

export interface INewSystemModalProp {
  open: boolean;
  approvalOperationEntity: IApprovalOperationEntity;
  onAddIn: (e: any) => void;
  onSkip: (e: any) => void;
}

export interface NewSystemPopUpDialogState {}

export function NewSystemModal(props: INewSystemModalProp) {
  let [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);



  function handleSkip(e: any) {
    props.onSkip(e);
    setOpen(false);
  }

  function handleClose(event: any, reason: string) {
    if (reason === "backdropClick") {
      return;
    }
    setOpen(false);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={"new-system-modal"}
    >
      <div className={"new-system-content"}>
        <Typography className={"title"}>
          New System Approval Available
        </Typography>

        <div className="bg-container">
          <img
            alt=""
            src={"./NewSystemPopUpAssets/newSystemBg.svg"}
            className={"background-img"}
          />
          <div className={"approval-operation-container"}>
            <img
              alt=""
              src={`./DrawerMenuAssets/${props.approvalOperationEntity.id}.svg`}
              className={"approval-operation-img"}
            />
            <Typography className={"approval-operation-description"}>
              {props.approvalOperationEntity.description}
            </Typography>
          </div>
        </div>

        <Typography className={"message"}>
          {"The new system is now accessible for addition, and you can add it to Favourites from “User System Profile” via the settings menu"}
        </Typography>
      </div>

      <DialogActions className="action-container">
        <Button
          className={"action-btn cancel-btn"}
          onClick={() => {
            handleSkip({});
          }}
        >
          GOT IT
        </Button>
      </DialogActions>
    </Dialog>
  );
}
